import { StyledGlass } from "./styled"

const Glass = props =>{
    const { opacity, dark, delay, z, onClick } = props
    return <StyledGlass $opacity={opacity} $dark={dark} $delay={delay} $z={z} onClick={onClick}/>
}

export default Glass